import { IconButton } from '@mui/material';

import React from 'react';
import type { MouseEventHandler } from 'react';

import type { Props } from 'src/components/ui/Icon';
import Icon from 'src/components/ui/Icon';

import { styledComponent } from 'src/utils/styled';

const StyledIconButton = styledComponent(IconButton)`
    width: 3rem;
    padding: 0.55rem 0.25rem;
`;

type CommentIconProps = {
    dataTargetId: string;
    ariaLabel: string;
    onClick: MouseEventHandler<HTMLButtonElement> | undefined;
    iconProps?: Omit<Props, 'name'>;
};
const CommentIcon: React.FC<CommentIconProps> = ({
    dataTargetId,
    ariaLabel,
    onClick,
    iconProps = { size: '1.18rem' },
}) => (
    <StyledIconButton data-target-id={dataTargetId} aria-label={ariaLabel} onClick={onClick}>
        <Icon size="1.18rem" name="Comments" {...iconProps} />
    </StyledIconButton>
);

export default CommentIcon;
